module.exports = __webpack_public_path__ + "img/tick-circle.1ca50035.png";